import { isDesktop } from "react-device-detect";
import RequiredAuth from "./common/middleware/authPermission";
import RequiredPublicAuth from './common/middleware/authPublicPermission';

import Dashboard from "./containers/Dashboard/Dashboard";
import PersonalDetails from "./containers/PersonalDetails/PersonalDetails";
import LoginRegister from "./containers/LoginRegister/LoginRegister"
import DelegateDeposit from "./containers/DelegateDeposit/DelegateDeposit";
import CommissionIllustrate from "./containers/CommissionIllustrate/CommissionIllustrate";
import Contact from "./containers/ContactUs/Contact";
import Messages from "./containers/MessageCenter/Messages";
import Deposit from "./containers/Deposit/Deposit";
import CommissionReport from "./containers/CommissionReport/CommissionReport";
import TransactionReport from "./containers/TransactionReport/TransactionReport";
import BettingHistory from "./containers/BettingHistory/BettingHistory";
import Withdrawal from "./containers/Withdrawal/Withdrawal";
import PromoteLink from "./containers/PromoteLink/PromoteLink";
import MemberManagement from "./containers/MemberManagement/MemberManagement";
import MyWallet from "./containers/MyWallet/MyWallet";
import FinancialReport from "./containers/FinancialReport/FinancialReport";
import ForgetPassword from "./containers/LoginRegister/ForgetPassword";
import ChangeNewPassword from "./containers/LoginRegister/ChangeNewPassword";
import Home from "./containers/Home/Home";
import CommissionPlan from "./containers/CommissionPlan/CommissionPlan";
import ContactUsHome from "./containers/ContactUsHome/ContactUsHome";
import Products from "./containers/Products/Products";
import TermsAndConditions from "./containers/TermsAndConditions/TermsAndConditions";
import MobileRegionLanguage from "./components/RegionLanguage/MobileRegionLanguage";
import DownlineAgent from "./containers/DownlineAgent/DownlineAgent";

const routes = [
    // Home
    { path: "/", exact: true, name: "Home", component: Home, slug: "home" },

    // Commission Plan
    { path: "/commission-plan", exact: true, name: "CommissionPlan", component: CommissionPlan, slug: "commission-plan" },

    // Dashboard Home
    { path: "/dashboard", exact: true, name: "Dashboard", component: RequiredAuth(Dashboard), slug: "dashboard" },
    
    // Personal Details
    { path: "/personal-details", exact: true, name: "PersonalDetails", component: RequiredAuth(PersonalDetails), slug: "personal-details" },

    //Login Register
    { path: "/login", exact: true, name: "Login", component: RequiredPublicAuth(LoginRegister), slug: "login" },

    // Delegate Deposit
    { path: "/delegate-deposit", exact: true, name: "DelegateDeposit", component: DelegateDeposit, slug: "delegate-deposit" },
    
    // Commission Illustrate
    { path: "/commision-illustrate", exact: true, name: "CommissionIllustrate", component: CommissionIllustrate, slug: "commision-illustrate" },

    // Products
    { path: "/products", exact: true, name: "Products", component: Products, slug: "products" },

    // Terms and Conditions
    { path: "/terms-and-conditions", exact: true, name: "TermsAndConditions", component: TermsAndConditions, slug: "terms-and-conditions" },

    // Contact Us
    { path: "/contact", exact: true, name: "ContactUsHome", component: ContactUsHome, slug: "contact" },
    { path: "/contact-us", exact: true, name: "Contact", component: RequiredAuth(Contact), slug: "contact-us" },

    // Message Center
    { path: "/message-center", exact: true, name: "MessageCenter", component: RequiredAuth(Messages), slug: "message-center" },

    // Deposit
    { path: "/deposit", exact: true, name: "Deposit", component: RequiredAuth(Deposit), slug: "deposit" },

    // Commission Report
    { path: "/commission-report", exact: true, name: "CommissionReport", component: CommissionReport, slug: "commission-report" },

    // Transaction Report
    { path: "/transaction-report", exact: true, name: "TransactionReport", component: RequiredAuth(TransactionReport), slug: "transaction-report" },
    // Betting History
    { path: "/betting-history", exact: true, name: "BettingHistory", component: RequiredAuth(BettingHistory), slug: "betting-history" },

    // Withdrawal
    { path: "/withdrawal", exact: true, name: "Withdrawal", component: Withdrawal, slug: "withdrawal" },

    // Promote Link
    { path: "/promote-link", exact: true, name: "PromoteLink", component: RequiredAuth(PromoteLink), slug: "promote-link"},

    // My Wallet
    { path: "/my-wallet", exact: true, name: "MyWallet", component: RequiredAuth(MyWallet), slug: "my-wallet" },

    // Member Management
    { path: "/management", exact: true, name: "Management", component: RequiredAuth(MemberManagement), slug: "management" },
    
    // Downline Agent
    { path: "/downline-agent", exact: true, name: "DownlineAgent", component: RequiredAuth(DownlineAgent), slug: "downline-agent" },
    
    { path: "/financial-report", exact: true, name: "FinancialReport", component: FinancialReport, slug: "financial-report" },

    //Verify Forgot Password
    // { path: "/verify-forgot-password/:token", exact: true, name: "Verify Forgot Password", component: ForgetPasswordModal, slug: "verify-forgot-password" },
    //forget Password
    { path: "/forget-password", exact: true, name: "Verify Forgot Password", component: ForgetPassword, slug: "forget-password" },
    //Verify Forgot Password
    { path: "/verify-forgot-password/:token", exact: true, name: "Verify Forgot Password", component: ForgetPassword, slug: "verify-forgot-password" },
    //Change Password
    { path: "/change-password/:token", exact: true, name: "Change New Password", component: ChangeNewPassword, slug: "change-password" },
    { path: "/region-language", exact: true, name: "RegionLanguage", component: MobileRegionLanguage, slug: "region-language" },
];


export default routes;
